// en, fr

import validation_fr from "vee-validate/dist/locale/fr.json";
import validation_en from "vee-validate/dist/locale/en.json";
import cashflow_fr from "./../app/cashflow/locale/fr.js";
import cashflow_en from "./../app/cashflow/locale/en.js";
import gradeControl_fr from "./../app/geo/gradecontrol/locale/fr.js";
import gradeControl_en from "./../app/geo/gradecontrol/locale/en.js";
import mrmr_fr from "./../app/geo/MRMR/locale/fr.js";
import mrmr_en from "./../app/geo/MRMR/locale/en.js";
import abc_fr from "./../app/abc/locale/fr.js";
import abc_en from "./../app/abc/locale/en.js";
import kpu_en from "./../app/bsg/kpu/locale/en.js";
import kpu_fr from "./../app/bsg/kpu/locale/fr.js";
import drilling_en from "./../app/drilling/locale/en.js";
import drilling_fr from "./../app/drilling/locale/fr.js";
import decarbonization_en from "./../app/bsg/decarbonization/locale/en.js";
import decarbonization_fr from "./../app/bsg/decarbonization/locale/fr.js";

export default {
  en: {
    validation: validation_en.messages,
    validationcustom:
    {
      "decimal" : "The {_field_} field must contain only decimal values",
      "email" : "The {_field_} field is not a valid email address",
      "phoneNumber" : "The {_field_} field is not a valid phone number"
    },
    Dashboard: 'Dashboard',
    eCommerce: 'eCommerce',
    Home: 'Home',
    Apps: 'Apps',
    Todo: 'Todo',
    Chat: 'Chat',
    Email: 'Email',
    Calendar: 'Calendar',
    FullCalendar: 'Full Calendar',
    SimpleCalendar: 'Simple Calendar',
    Shop: 'Shop',
    ItemDetails: 'Item Details',
    Cart: 'Cart',
    WishList: 'Wish List',
    Checkout: 'Checkout',
    UI: 'UI',
    DataList: 'Data List',
    ListView: 'List View',
    ThumbView: 'Thumb View',
    Grid: 'Grid',
    Vuexy: 'Vuexy',
    Vuesax: 'Vuesax',
    Tailwind: 'Tailwind',
    Colors: 'Colors',
    Card: 'Card',
    Basic: 'Basic',
    Statistics: 'Statistics',
    Analytics: 'Analytics',
    CardActions: 'Card Actions',
    CardColors: 'Card Colors',
    Table: 'Table',
    agGridTable: 'agGrid Table',
    Components: 'Components',
    Alert: 'Alert',
    Avatar: 'Avatar',
    Badge: 'Badge',
    Breadcrumb: 'Breadcrumb',
    Button: 'Button',
    ButtonGroup: 'Button Group',
    Chip: 'Chip',
    Collapse: 'Collapse',
    Dialogs: 'Dialogs',
    Divider: 'Divider',
    DropDown: 'DropDown',
    List: 'List',
    Loading: 'Loading',
    Navbar: 'Navbar',
    Notifications: 'Notifications',
    Pagination: 'Pagination',
    Popup: 'Popup',
    Progress: 'Progress',
    Print: 'Print',
    Sidebar: 'Sidebar',
    Slider: 'Slider',
    Tabs: 'Tabs',
    Tooltip: 'Tooltip',
    Upload: 'Upload',
    FormsAndTable: 'Forms & Table',
    FormElements: 'Form Elements',
    Select: 'Select',
    Switch: 'Switch',
    Checkbox: 'Checkbox',
    Radio: 'Radio',
    Input: 'Input',
    NumberInput: 'Number Input',
    Textarea: 'Textarea',
    FormLayouts: 'Form Layouts',
    FormWizard: 'Form Wizard',
    FormValidation: 'Form Validation',
    FormInputGroup: 'Form Input Group',
    Pages: 'Pages',
    Authentication: 'Authentication',
    Login: 'Login',
    Logout: 'Logout',
    ChangeProject: "Change project",
    Register: 'Register',
    ForgotPassword: 'Forgot Password',
    ResetPassword: 'Reset Password',
    LockScreen: 'Lock Screen',
    Miscellaneous: 'Miscellaneous',
    ComingSoon: 'Coming Soon',
    Error: 'Error',
    Warning : "Warning",
    LoadingError: 'Unable to load the expected data',
    SavingError: 'Unable to save data',
    DeletingError: 'Unable to delete data',
    ConcurrencyError: 'Unable to save data - Concurrency issue',
    ConcurrencyMessage : "The model was saved since your last refresh.  Please retry your operation",
    404: '404',
    500: '500',
    NotAuthorized: 'Not Authorized',
    Maintenance: 'Maintenance',
    Profile: 'Profile',
    Help : 'Help',
    HelpText : 'Please describe your issue',
    User: 'User',
    View: 'View',
    Edit: 'Edit',
    Duplicate: 'Duplicate',
    Apply : 'Apply',
    CanEdit: 'Can Edit',
    Delete: 'Delete',
    Restore: 'Restore',
    UserSettings: 'User Settings',
    Invoice: 'Invoice',
    Unknown : 'Unknown',
    BackHome : 'Back to Home',
    401 : "401 - Unauthorized!",
    FAQ: 'FAQ',
    Search: 'Search',
    SearchPlaceholder: 'Search...',
    KnowledgeBase: 'Knowledge Base',
    ChartsAndMaps: 'Charts & Maps',
    Charts: 'Charts',
    ApexCharts: 'Apex Charts',
    chartjs: 'chartjs',
    echarts: 'echarts',
    chartist: 'chartist',
    GoogleMap: 'Google Map',
    Extensions: 'Extensions',
    QuillEditor: 'Quill Editor',
    DragAndDrop: 'Drag & Drop',
    Datepicker: 'Datepicker',
    DatetimePicker: 'Datetime Picker',
    AccessControl: 'Access Control',
    I18n: 'I18n',
    Carousel: 'Carousel',
    Clipboard: 'Clipboard',
    ContextMenu: 'Context Menu',
    StarRatings: 'Star Ratings',
    Autocomplete: 'Autocomplete',
    Tree: 'Tree',
    // "Import/Export": 'Import/Export',
    Import: 'Import',
    Post: 'Post',
    CancelPost: 'Cancel posting',
    Export: 'Export',
    Submit: 'Submit',
    Cancel: 'Cancel',
    Save: 'Save',
    CancelImport: "Cancel Import",
    Approve : 'Approve',
    Unapprouve : 'Unapprove',
    ExportSelected: 'Export Selected',
    Others: 'Others',
    MenuLevels: 'Menu Levels',
    MenuLevel2p1: 'Menu Level 2.1',
    MenuLevel2p2: 'Menu Level 2.2',
    MenuLevel3p1: 'Menu Level 3.1',
    MenuLevel3p2: 'Menu Level 3.2',
    DisabledMenu: 'Disabled Menu',
    Support: 'Support',
    Documentation: 'Documentation',
    RaiseSupport: 'Raise Support',
    AddNew : 'Add new',
    Add : 'Add',
    New : 'New',
    Deleted : 'Deleted',
    Of : 'of',
    Action : 'Action',
    Success : 'Success',
    SaveSuccess : 'Save completed',
    InsertSuccess : 'Insert completed',
    Gold : 'Gold',
    Silver : 'Silver',
    Copper : 'Copper',
    Zinc : 'Zinc',
    Lead : 'Lead',
    Carbon : 'Carbon',
    Sulfur : 'Sulfur',
    Refresh : 'Refresh',
    Filters : 'Filters',
    SelectDate : 'Select a date',
    StartDate : 'Start date',
    SelectStartDate : 'Select a start date',
    SelectEndDate : 'Select an end date',
    Next : 'Next',
    Back : 'Back',
    EndDate : 'End date',
    Reports : "Reports",
    Project : "Project",
    Projects : "Projects",
    NoResult : "No results",
    Explore : "Explore portal",
    Actual : "Actual",
    Budget : "Budget",
    ThisMonth : "This Month",
    LastMonth : "Last Month",
    YearOnYear : "Year On Year",
    Previous : "Previous",
    Module : "Module",
    RequestType : "Request Type",
    UploadFailedTitle : "Upload failed",
    UploadFailed : "The upload has failed",
    Comments : "Comments",
    NA: "N/A",
    ModuleEnum: {
      '0' : "Grade Control",
      '1' : "MRMR",
      '2' : "KPU",
      '3' : "CashFlow / LOM"
    },
    HelpType: {
      '0' : "Idea",
      '1' : "Issue"
    },
    HelpSuccess: "Your request has been sucessfully submitted",
    Element: {
      '0' : "Gold",
      '1' : "Silver",
      '2' : "Copper",
      '3' : "Zinc",
      '4' : "Lead",
      '5' : "Carbon",
      '6' : "Sulfur"
    },
    MeasuredElement: {
      'Title' : 'Element',
      '0' : "Gold",
      '1' : "Silver",
      '2' : "Copper",
      '3' : "Zinc",
      '4' : "Lead",
      '5' : "Carbon",
      '6' : "Sulfur",
      '7' : "Others"
    },
    Shift: {
      '0' : 'Day',
      '1' : 'Night'
    },
    QCType: {
      '0' : 'Assay',
      '1' : 'PrepDup',
      '2' : 'PulpDup',
      '3' : 'RejectPrepDup'
    },
    AuditStatus : {
      '0' : "Submitted",
      '1' : "Refused",
      '2' : "Approved",
      '3' : "Promoted",
      '4' : "Approved By Engineering"
    },
    SampleCategory: {
      'Title' : 'Type',
      '0' : "Other",
      '1' : "Carrot",
      '2' : "Chip",
      '3' : "Muck",
      '4' : "Standard"
    },
    SampleStatus: {
      'Title' : 'Status',
      '0' : "Imported No Exclusion",
      '1' : "Imported With Exclusion",
      '2' : "Orphan",
      '3' : "Not Imported"
    },
    BSG: {
      Title : 'Business Strategy'
    },
    CashFlow: cashflow_en.en,
    KPU: kpu_en.en,
    Decarbonization: decarbonization_en.en,
    GradeCalculation : {
      'Name' : "Grade calculation",
      '0' : "Sample Only",
      '1' : "Sample Only - Capped",
      '2' : "Sample Or Forecast",
      '3' : "Sample Or Forecast - Capped"
    },
    Material : {
      '0' : "Ore",
      '1' : "Acid",
      '2' : "Waste",
      '3' : "Standby"
    },
    Location : {
      '0' : "Development",
      '1' : "Production",
      '2' : "Stock Pile",
      '3' : "Open Pit"
    },
    MRMRResourceType : {
      '0' : "Potential Mineral",
      '1' : "Inferred",
      '2' : "Indicated",
      '3' : "Measured",
      '4' : "Probable",
      '5' : "Proven"
    },
    SampleUnit : {
      '0' : "n/a",
      '1' : "%",
      '2' : "g/t",
      '3' : "kcps",
      '4' : "kg/m³",
      '5' : "mg",
      '6' : "ppm",
      '7' : "?",
      '8' : "g",
      '9' : "kg"
    },
    Geo: {
      Title: "MRMR",
      NSR : {
        Title : "NSR",
        Analytics : {
          Title : "NSR Analytics"
        }
      },
      QAQC : {
        Title: "QA/QC"
      }
    },
    GeoScenarioPage: {
      Name : 'Name',
      Title : "Scenarios",
      ScenarioList : 'Scenario List',
      AddScenario: 'CREATE NEW SCENARIO',
      UpdateScenario : 'UPDATE SCENARIO',
      Project : 'Project',
      BlockModel : 'Block Model',
      NSRResults : 'NSR Results',
      Zone : 'Zone',
      Tonnage: 'Tonnage',
      BaseNSR: 'NSR',
      BaseNSRPerTon: 'NSR/Ton',
      BaseGoldEq: 'Gold equiv',
      ScenarioNSR: 'Scenario NSR',
      ScenarioNSRPerTon: 'Scenario NSR/Ton ',
      ScenarioGoldEq: 'Scenario Gold Equiv',
      DeltaNSR: 'NSR Delta',
      DeltaNSRPerTon: 'NSR/Tonne Delta',
      DeltaGoldEq: 'Gold Equiv Delta',
      DefaultRoyalties : 'Default Royalties',
      DefaultRefiningCharges : 'Default Refining Charges',
      IncludeSilver: 'Include Silver',
      IncludeCopper: 'Include Copper',
      GoldPrice: 'Gold Price',
      SilverPrice: 'Silver Price',
      Estimator : 'Estimator',
      GoldEstimator : 'Gold Estimator',
      CNPayable : 'Payable',
      CuPayable : 'Payable',
      RefiningCost : 'Refining Cost',
      CNRecoveryPct : 'Recovery Rate',
      CuRecoveryPct : 'Recovery Rate',
      CNRefiningCharge : 'Refining Charges',
      CuRefiningCharge : 'Refining Charges',
      DisplayOnlyMine : "My scenarios",
      PayableDeductable : "Deductable",
      CNProcess : "Leaching",
      CuProcess : "Copper Flotation",
      ScenarioDeleted : "The selected scenario was successfully deleted",
      ConfirmDelete : "Do you really want to delete the scenario {scenarioName}?",
      CuConcentrateQualityPct : "Copper concentrate Quality",
      CuPenalty : "Penalty",
      CuBaseTreatmentCharge : "Base Treatment Charge & Flat Fee"
    },

    JobsCenter: {
      NoJobsRunning: "No jobs currently running",
      ViewJobsHistory: "View jobs history",
      StartedOn: "Started on {date}",
      CompletedOn: "Completed on {date}",
      CalculationPending: "Calculation pending",
      CalculationInProgress: "Calculation in progress",
      CalculationCompleted: "Calculation completed",
      CalculationFailed: "Calculation failed",
      CalculationSkipped: "Calculation skipped",
      NotificationAcknowledgementFailed: "Notification acknowledgement failed. {error}",
      JobsHistory: "Job history",
      JobInProgress: "Job in progress",

      Time: {
        YearsAgo: "{years} years ago",
        DaysAgo: "{days} days ago",
        HoursAgo: "{hours} hours ago",
        MinutesAgo: "{minutes} minutes ago",
        SecondsAgo: "{seconds} seconds ago",

        YearAgo: "a year ago",
        DayAgo: "yesterday",
        HourAgo: "1 hour ago",
        MinuteAgo: "1 minute ago",
        SecondAgo: "1 second ago",

        JustNow: "Just now"
      }
    },

    Currency: {
      '0': "USD",
      '1': "CAD",
      '2': "EUR",
      '3': "MXN"
    },

    No: "No",
    Yes: "Yes",

    GradeControl : gradeControl_en.en,
    ABC: abc_en.en,
    MRMR: mrmr_en.en,
    Drilling: drilling_en.en,
    UserGuide: "User Guide"
  },
  fr: {
    validation: validation_fr.messages,
    validationcustom:
    {
      "decimal": "Le champ {_field_} ne peut contenir que des décimales",
      "email" : "Le champ {_field_} n'est pas une adresse de courriel valide",
      "phoneNumber" : "Le champ {_field_} n'est pas un téléphone valide"
    },
    Dashboard: 'Tableau de bord',
    eCommerce: 'commerce électronique',
    Home: 'Accueil',
    Apps: 'Applications',
    Todo: 'Faire',
    Chat: 'Bavarder',
    Email: 'Email',
    Calendar: 'Calendrier',
    FullCalendar: 'Calendrier complet',
    SimpleCalendar: 'Calendrier simple',
    Shop: 'Boutique',
    ItemDetails: 'Détails de l\'article',
    Cart: 'Chariot',
    WishList: 'Liste de souhaits',
    Checkout: 'Check-out',
    UI: 'UI',
    DataList: 'Liste de données',
    ListView: 'Voir la liste',
    ThumbView: 'Thumb View',
    Grid: 'la grille',
    Vuexy: 'Vuexy',
    Vuesax: 'Vuesax',
    Tailwind: 'Tailwind',
    Colors: 'Couleurs',
    Card: 'Carte',
    Basic: 'De base',
    Statistics: 'Statistiques',
    Analytics: 'Analytique',
    CardActions: 'Actions de carte',
    CardColors: 'Couleurs de la carte',
    Table: 'Table',
    agGridTable: 'tableau agGrid',
    Components: 'Composants',
    Alert: 'Alerte',
    Avatar: 'Avatar',
    Badge: 'Badge',
    Breadcrumb: 'Breadcrumb',
    Button: 'Bouton',
    ButtonGroup: 'Groupe de boutons',
    Chip: 'Puce',
    Collapse: 'Effondrer',
    Dialogs: 'Dialogues',
    Divider: 'Diviseur',
    DropDown: 'Menu déroulant',
    List: 'liste',
    Loading: 'Chargement',
    Navbar: 'Barre de navigation',
    Notifications: 'Les notifications',
    Pagination: 'Pagination',
    Popup: 'Apparaitre',
    Progress: 'Le progrès',
    Print: 'Imprimer',
    Sidebar: 'Barre latérale',
    Slider: 'Curseur',
    Tabs: 'Onglets',
    Tooltip: 'Info-bulle',
    Upload: 'Télécharger',
    FormsAndTable: 'Formulaires et tableau',
    FormElements: 'Éléments de formulaire',
    Select: 'Sélectionner',
    Switch: 'Commutateur',
    Checkbox: 'Case à cocher',
    Radio: 'Radio',
    Input: 'Contribution',
    NumberInput: 'Nombre d\'entrée',
    Textarea: 'Textarea',
    FormLayouts: 'Dispositions de formulaire',
    FormWizard: 'Assistant de formulaire',
    FormValidation: 'Validation du formulaire',
    FormInputGroup: 'Groupe de saisie de formulaire',
    Pages: 'Pages',
    Authentication: 'Authentification',
    Login: 'S\'identifier',
    Logout: 'Se déconnecter',
    ChangeProject: "Changer de projet",
    Register: 'registre',
    ForgotPassword: 'Mot de passe oublié',
    ResetPassword: 'réinitialiser le mot de passe',
    LockScreen: 'Écran verrouillé',
    Miscellaneous: 'Divers',
    ComingSoon: 'Arrive bientôt',
    Error: 'Erreur',
    Warning : "Avertissement",
    LoadingError: 'Impossible de charger les données relative au bon fonctionnement du formulaire',
    SavingError: "La sauvegarde n'a pas pu être effectuée",
    ConcurrencyError: "La sauvegarde n'a pas pu être effectuée - Erreur de concurrence",
    ConcurrencyMessage : "Le modèle sauvegardé a été modifié depuis votre dernier rafrachissement.  Veuillez refaire l'opération",
    DeletingError: "La suppression n'a pas pu être effectuée",
    404: '404',
    500: '500',
    NotAuthorized: 'Pas autorisé',
    Maintenance: 'Entretien',
    Profile: 'Profil',
    Help : 'Aide',
    HelpText : 'Merci de décrire votre problématique',
    User: 'Utilisateur',
    View: 'Vue',
    Edit: 'Édition',
    Duplicate: 'Dupliquer',
    Apply : 'Appliquer',
    CanEdit: 'Peut éditer',
    Delete: 'Supprimer',
    Restore : 'Restaurer',
    UserSettings: 'Paramètres utilisateur',
    Invoice: 'Facture d\'achat',
    Unknown : 'Inconnu',
    BackHome : "Retour à l'accueil",
    401 : "401 - Non-autorisé!",
    FAQ: 'FAQ',
    Search: 'Chercher',
    SearchPlaceholder: 'Rechercher...',
    KnowledgeBase: 'Base de connaissances',
    ChartsAndMaps: 'Graphiques Et Cartes',
    Charts: 'Graphiques',
    ApexCharts: 'Apex Charts',
    chartjs: 'chartjs',
    echarts: 'echarts',
    chartist: 'chartist',
    GoogleMap: 'Google Carte',
    Extensions: 'Extensions',
    QuillEditor: 'Éditeur de piquants',
    DragAndDrop: 'Drag & Drop',
    Datepicker: 'Sélecteur de date',
    DatetimePicker: 'Sélecteur de date / heure',
    AccessControl: 'Contrôle d\'accès',
    I18n: 'I18n',
    Carousel: 'Carrousel',
    Clipboard: 'Presse-papiers',
    ContextMenu: 'Menu contextuel',
    StarRatings: 'Classement par étoiles',
    Autocomplete: 'Terminé automatiquement',
    Tree: 'Arbre',
    // "Import/Export": 'Importation/Exportation',
    Import: 'Importation',
    Post: 'Comptabiliser',
    CancelPost: 'Annuler la comptabilisation',
    Submit: 'Soumettre',
    Cancel: 'Annuler',
    Save: 'Sauvegarder',
    CancelImport: "Annuler l'importation",
    Export: 'Exportation',
    Approve : 'Approbation',
    Unapprouve : 'Désapprobation',
    ExportSelected: 'Exporter sélectionné',
    Others: 'Autre',
    MenuLevels: 'Niveaux de menu',
    MenuLevel2p1: 'Niveau de menu 2.1',
    MenuLevel2p2: 'Niveau de menu 2.2',
    MenuLevel3p1: 'Niveau de menu 3.1',
    MenuLevel3p2: 'Niveau de menu 3.2',
    DisabledMenu: 'Menu désactivé',
    Support: 'Soutien',
    Documentation: 'Documentation',
    RaiseSupport: 'Augmenter le soutien',
    AddNew : 'Ajouter',
    Add : 'Ajouter',
    New : 'Nouveau',
    Deleted : 'Supprimé',
    Of : 'de',
    Action : 'Action',
    Success : 'Succès',
    SaveSuccess : 'Sauvegarde complétée',
    InsertSuccess : 'Ajout complété',
    Gold : 'Or',
    Silver : 'Argent',
    Copper : 'Cuivre',
    Zinc : 'Zinc',
    Lead : 'Plomb',
    Carbon: 'Carbone',
    Sulfur: 'Sulfure',
    Refresh : 'Rafraîchir',
    Filters : 'Filtres',
    SelectDate : 'Sélectionnez une date',
    StartDate : 'Date de début',
    EndDate : 'Date de fin',
    Reports : "Rapports",
    Project : "Projet",
    Projects : "Projets",
    SelectStartDate : 'Sélectionnez la date de début',
    SelectEndDate : 'Sélectionnez la date de fin',
    Next : 'Suivant',
    Back : 'Précédent',
    NoResult : "Aucun résultats",
    Explore : "Explorer le portail",
    Actual : "Actuel",
    Budget : "Budget",
    ThisMonth : "Mois Actuel",
    LastMonth : "Mois Dernier",
    YearOnYear : "Comparatif annuel",
    Previous : "Précédant",
    Module : "Module",
    RequestType : "Type de requête",
    UploadFailedTitle: "Échec du téléversement",
    UploadFailed : "Le téléversement a échoué pour une raison technique.",
    Comments : "Commentaires",
    NA: "N/A",
    ModuleEnum: {
      '0' : "Grade Control",
      '1' : "MRMR",
      '2' : "KPU",
      '3' : "CashFlow / LOM"
    },
    HelpType: {
      '0' : "Idée",
      '1' : "Problème"
    },
    HelpSuccess: "Votre demande a été correctement transmise",
    Element: {
      '0' : "Or",
      '1' : "Argent",
      '2' : "Cuivre",
      '3' : "Zinc",
      '4' : "Plomb",
      '5' : "Carbone",
      '6' : "Sulfure"
    },
    MeasuredElement: {
      'Title' : 'Élément',
      '0' : "Or",
      '1' : "Argent",
      '2' : "Cuivre",
      '3' : "Zinc",
      '4' : "Plomb",
      '5' : "Carbone",
      '6' : "Sulfure",
      '7' : "Autres"
    },
    SampleStatus: {
      'Title' : 'Statut',
      '0' : "Importé sans exclusion",
      '1' : "Importé avec exclusion",
      '2' : "Orphelin",
      '3' : "Non importé"
    },
    SampleCategory: {
      'Title' : "Type",
      '0' : "Autre",
      '1' : "Carrot",
      '2' : "Chip",
      '3' : "Muck",
      '4' : "Standard"
    },
    Shift: {
      '0' : 'Jour',
      '1' : 'Nuit'
    },
    QCType: {
      '0' : 'Assay',
      '1' : 'PrepDup',
      '2' : 'PulpDup',
      '3' : 'RejectPrepDup'
    },
    AuditStatus : {
      '0' : "Envoyé",
      '1' : "Refusé",
      '2' : "Approuvé",
      '3' : "Promu",
      '4' : "Approuvé par l'ingénierie"
    },
    BSG: {
      Title : "Stratégie d'affaire"
    },
    CashFlow: cashflow_fr.fr,
    KPU: kpu_fr.fr,
    Decarbonization: decarbonization_fr.fr,
    GradeCalculation : {
      'Name' : "Calcul de teneur",
      '0' : "Échantillons seulement",
      '1' : "Échantillons seul. - Écrêté",
      '2' : "Échantillons ou prévisions",
      '3' : "Échantillons ou prev. - Écrêté"
    },
    Material : {
      '0' : "Minerai",
      '1' : "Acide",
      '2' : "Stérile",
      '3' : "En attente"
    },
    Location : {
      '0' : "Développement",
      '1' : "Production",
      '2' : "Halde",
      '3' : "Fosse"
    },
    MRMRResourceType : {
      '0' : "Minéral potentiel",
      '1' : "Inféré",
      '2' : "Indiqué",
      '3' : "Mesuré",
      '4' : "Probable",
      '5' : "Prouvé"
    },
    SampleUnit : {
      '0' : "n/a",
      '1' : "%",
      '2' : "g/t",
      '3' : "kcps",
      '4' : "kg/m³",
      '5' : "mg",
      '6' : "ppm",
      '7' : "?",
      '8' : "g",
      '9' : "kg"
    },
    Geo: {
      Title: "MRMR",
      NSR : {
        Title : "Analyses NSR"
      },
      QAQC : {
        Title: "QA/QC"
      }
    },
    GeoScenarioPage: {
      Title : "Scénarios",
      Name : 'Nom',
      ScenarioList : 'Liste des scénarios',
      AddScenario: 'AJOUTER UN SCÉNARIO',
      UpdateScenario : 'MODIFIER UN SCÉNARIO',
      Project : 'Projet',
      BlockModel : 'Modèle Bloc',
      NSRResults : 'NSR',
      Zone : 'Zone',
      Tonnage: 'Tonnage',
      BaseNSR: 'NSR Modèle',
      BaseNSRPerTon: 'NSR/Tonne',
      BaseGoldEq: 'Equiv. Or',
      ScenarioNSR: 'NSR Scénario',
      ScenarioNSRPerTon: 'NSR/Tonne Scénario',
      ScenarioGoldEq: 'Equiv. Or Scénario',
      DeltaNSR: 'Diff. NSR',
      DeltaNSRPerTon: 'Diff NSR/Tonne',
      DeltaGoldEq: 'Diff Equiv. Or',
      DefaultRefiningCharges: 'Frais de raffinage par défaut',
      DefaultRoyalties : 'Royautés',
      IncludeSilver: 'Inclure argent',
      IncludeCopper: 'Inclure cuivre',
      GoldPrice: 'Prix Or',
      SilverPrice: 'Prix Argent',
      Estimator : 'Estimation',
      GoldEstimator : 'Estimation Or',
      CNPayable : 'Payable',
      CuPayable : 'Payable',
      CNRecoveryPct : 'Taux de récupération',
      CuRecoveryPct : 'Taux de récupération',
      CNRefiningCharge : 'Frais de raffinage',
      CuRefiningCharge : 'Frais de raffinage',
      DisplayOnlyMine : "Mes scénarios",
      PayableDeductable : "Déductibles",
      CNProcess : "Cyanuration",
      CuProcess : "Flottation cuivre",
      ScenarioDeleted : "Le scénario a été correctement supprimé",
      ConfirmDelete : "Souhaitez-vous réellement supprimer le scénario {scenarioName}?",
      CuConcentrateQualityPct : "Qualité du concentrée de cuivre",
      CuPenalty : "Pénalités",
      CuBaseTreatmentCharge : "Frais de traitement et arbitraire"
    },

    JobsCenter: {
      NoJobsRunning: "Aucune tâche en cours",
      ViewJobsHistory: "Voir l'historique des tâches",
      StartedOn: "Commencé le {date}",
      CompletedOn: "Complété le {date}",
      CalculationPending: "Calcul en attente",
      CalculationInProgress: "Calcul en cours",
      CalculationCompleted: "Calcul complété",
      CalculationFailed: "Calcul échoué",
      CalculationSkipped: "Calcul ignoré",
      NotificationAcknowledgementFailed: "Échec de la confirmation de la notification. {error}",
      JobsHistory: "Historique des tâches",
      JobInProgress: "Job in progress",

      Time: {
        YearsAgo: "il y a {years} ans",
        DaysAgo: "il y a {days} jours",
        HoursAgo: "il y a {hours} heures",
        MinutesAgo: "il y a {minutes} minutes",
        SecondsAgo: "il y a {seconds} secondes",

        YearAgo: "il y a un an",
        DayAgo: "hier",
        HourAgo: "il y a 1 heure",
        MinuteAgo: "il y a 1 minute",
        SecondAgo: "il y a 1 seconde",

        JustNow: "Maintenant"
      }
    },

    Currency: {
      '0': "USD",
      '1': "CAD",
      '2': "EUR",
      '3': "MXN"
    },

    No: "Non",
    Yes: "Oui",

    GradeControl : gradeControl_fr.fr,
    ABC: abc_fr.fr,
    MRMR: mrmr_fr.fr,
    Drilling: drilling_fr.fr,
    UserGuide: "Guide de l'utilisateur"
  }
}
